module.exports = __webpack_public_path__ + "static/img/pharmaceuticalEnterprises2.7d0c399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/pharmaceuticalEnterprises2.png
// module id = ZJdt
// module chunks = 1